
/*
 * Baselayer Promotional Pricing
 * Updates promotional prices when product variants change.
 * Display only – does not change checkout prices.
 */

(function () {
  'use strict';

  function updatePromo(event) {
    const promo = document.querySelector('.baselayer-promo-price');

    if (!promo) return;

    const variant = event.detail && event.detail.variant;

    if (!variant || variant.available === false) {
  promo.hidden = true;
  return;
}

    // Ensure the event belongs to the displayed product
    const productId = Number(promo.dataset.promoProductId);
    const variantProductId = Number(variant.product_id);

    if (
      productId &&
      variantProductId &&
      productId !== variantProductId
    ) {
      return;
    }

    const price = Number(variant.price);
    const comparePrice = Number(variant.compare_at_price) || 0;

    if (!Number.isFinite(price) || price <= 0) return;

    // RRP is the higher of price and compare-at price
    const rrp = Math.max(price, comparePrice);

    const discount = Number(promo.dataset.promoPercent);
    if (!Number.isFinite(discount) || discount <= 0 || discount >= 100) {
      return;
    }

    // Shopify prices are stored in pence
    const promotionalPrice = Math.round(
      rrp * (100 - discount) / 100
    );

    function formatMoney(amount) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return window.Shopify.formatMoney(
          amount,
          promo.dataset.moneyFormat
        );
      }

      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount / 100);
    }

    const rrpElement = promo.querySelector('[data-promo-rrp]');
    const priceElement = promo.querySelector('[data-promo-price]');
    const normalElement = promo.querySelector('[data-promo-normal]');

    if (rrpElement) rrpElement.textContent = formatMoney(rrp);
    if (priceElement) priceElement.textContent = formatMoney(promotionalPrice);
    if (normalElement) normalElement.textContent = formatMoney(rrp);

    promo.hidden = false;
  }

  // Capture the Empire theme's variant-change event
  document.addEventListener('variant-change', updatePromo, true);
})();
